import {
  useDeleteMutation,
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
} from "slices/api";
import { PAYMENT_HISTORY } from "tagTypes";

export const useGetPaymentHistoryQuery = () =>
  useGetQuery({
    endpoint: "/payment-transaction/user",
    tags: [PAYMENT_HISTORY],
  });

export const useLazyGetOutstandingReportsQuery = () => {
  const [getOutstandingReportData, data] = useLazyGetQuery();
  const report = async (query = {}) =>
    await getOutstandingReportData(
      {
        endpoint: "/report/outstanding-details-of-consumer",
        query,
        tags: [],
      },
      true
    ).unwrap();
  return [report, data];
};

export const useLazyGetOutstandingInvoiceQuery = () => {
  const [getOutstandingInvoiceData, data] = useLazyGetQuery();
  const invoice = async (query = {}) =>
    await getOutstandingInvoiceData(
      {
        endpoint: "/report/outstanding-invoice-details-of-consumer",
        query,
        tags: [],
      },
      true
    ).unwrap();
  return [invoice, data];
};

export const useLazyGetPaymentTransactionConfirmation = () => {
  const [getPaymentConfirmation, data] = useLazyGetQuery();
  const paymentConfirmation = async (query = {}) =>
    await getPaymentConfirmation(
      {
        endpoint: "payment-transaction/payment-confirmation",
        query,
        tags: [],
      },
      true
    ).unwrap();
  return [paymentConfirmation, data];
};

export const usePostPaymentHistoryFileMutation = () => {
  const [uploadPaymentHistoryFile, data] = usePostMutation();
  const addPaymentHistoryFile = async (payload) =>
    await uploadPaymentHistoryFile({
      endpoint: "/payment-transaction-upload",
      tags: [PAYMENT_HISTORY],
      payload: payload || {},
      toastMessage: "File uploaded successfully",
    }).unwrap();
  return [addPaymentHistoryFile, data];
};

export const usePostOtherUtilityFinancePriviousBillPayment = () => {
  const [uploadPreviousPaymentHistory, data] = usePostMutation();
  const addPreviousPaymentHistory = async (payload) =>
    await uploadPreviousPaymentHistory({
      endpoint: "/bill-payment-settlement",
      tags: [PAYMENT_HISTORY],
      payload: payload || {},
      toastMessage: "File uploaded successfully",
    }).unwrap();
  return [addPreviousPaymentHistory, data];
};

export const usePutPaymentHistoryFileMutation = () => {
  const [updatePaymentDetails, data] = usePutMutation();
  const updatePaymentData = async (payload) =>
    await updatePaymentDetails({
      endpoint: "/payment-transaction/update",
      tags: [PAYMENT_HISTORY],
      payload: payload || {},
      toastMessage: "Payment details updated successfully",
    }).unwrap();
  return [updatePaymentData, data];
};

export const useDeletePaymentHistoryDetailMutation = () => {
  const [deletePaymentDetails, data] = useDeleteMutation();
  const deletePaymentData = async (id) =>
    await deletePaymentDetails({
      endpoint: `/payment-transaction/${id}/delete`,
      tags: [PAYMENT_HISTORY],
      toastMessage: "Payment details deleted successfully",
    }).unwrap();
  return [deletePaymentData, data];
};
